import {createLoggerMiddleware} from 'src/shared/logger/middleware';

export const logger = createLoggerMiddleware({
  component: 'XHS-PAGE-HOME',
  page: 'home',
  types: [],
});
